module.exports = __webpack_public_path__ + "static/media/undraw_page_not_found_su7k.a60a1b12.png";